<template>
	<div class="jmhome">
	    
	    <div class="bzt">
	        <div class="centre bztType">
				<div class="top">
					<div class="bt">
						<img class="bt-img" src="/static/img/comm/home.png" />
						<div style="width: 40%;">{{zexiantu.title}}</div>
						<div>
							
						</div>
					</div>
					<bingzhuangtu v-if="hackResetbingzhuangtu"  :data1="bzt.data1" :name='bzt.name' :data2='bzt.data2'></bingzhuangtu>
				</div>
				
			</div>
		</div>
		<div class="nr">
			
			<div class="centre">
				<div class="top">
					<div class="bt">
						<img class="bt-img" src="/static/img/comm/home.png" />
						<div style="width: 40%;">{{zexiantu.title}}</div>
						<div>
							
						</div>
					</div>
					<zexiantu v-if="hackResetzexiantu" :data1='zexiantu.data1' :minWidth="minWidth" :data2="zexiantu.data2" :date="zexiantu.date"></zexiantu>
				</div>
				
			</div>
		
		</div>
		<div class="tjan">
			<Button class='tjan-s' shape="circle" @click="shangyinian">上一年</Button>
			<div class="tjan-je">{{year}}年</div>
			<Button shape="circle" @click="xiayinian">下一年</Button>
		</div>
	
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import zexiantu from '@/components/comm/home/zexiantu.vue'
	import bingzhuangtu from '@/components/comm/home/bingzhuangtu.vue'
	export default {

		data() {
			return {
				year:2019,
				month:11,
				minWidth:document.body.clientWidth-350+'px',
				single:'0',
				hackResetzexiantu: false,
				hackResetbingzhuangtu:false,
				zxtMap:{},
				
				zexiantu:{
					title: '商品类型销量(总计)',
					data1: ['饮料1', '香烟'],
					data2:[],
					date:[]
					
				},
				bzt: {
						title: '商品类型',
						data1: [],
						name: '商品分类',
						data2: [
							/* {
								value: 335,
								name: '小吃'
							} */
						]
					
				},
			}
		},
		methods: {
			xiayinian(){
				let _this=this
					_this.year++
				_this.queryzexiantu()
				
			},
			shangyinian(){
				let _this=this
				_this.year--
				_this.queryzexiantu()
			},
			queryzexiantu() {
				let _this=this
				let url=http.url + '/fin/report/comm/home/alliance/comm'
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: url,
				    data: {
						year:_this.year,
						month:_this.month
					},
					_this: _this,
					success: function(data) {
						_this.zxtMap=data.map
						_this.huizhiZexiantu()
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			huizhiZexiantu(){
				
				let _this=this
				_this.zexiantu.data2=_this.zxtMap.series
				_this.zexiantu.date=_this.zxtMap.categories
				_this.zexiantu.data1=_this.zxtMap.types
				
				
				_this.bzt.data2=_this.zxtMap.bzt
				_this.bzt.data1=_this.zxtMap.types
				//重新渲染子组件
				this.hackResetzexiantu = false
				this.hackResetbingzhuangtu = false
				this.$nextTick(() => {
					this.hackResetzexiantu = true
					this.hackResetbingzhuangtu = true
				})
			},
			onchange(){
				let _this=this
				_this.queryzexiantu()
			},
		},
		components: {
			zexiantu,bingzhuangtu
		},
		created() {
			let _this = this
			var date = new Date();
			_this.year=parseInt(date.getFullYear()); //获取完整的年份(4位)
			_this.month=parseInt(date.getMonth())+1; //获取当前月份(0-11,0代表1月)
			_this.queryzexiantu()
		}

	}
</script>
<style scoped lang="less">
	.jmhome {
		display: flex;
		flex-direction: column;
	}
    
	.nr {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		
		.left {
			.top {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}

			.down {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}
		}
		
		.centre {
           

			.top {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}

			.down {
				padding: 5px 5px 0px 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}
		}

		.right {}

	}
	.bzt{
		display: flex;
		.bztType{
			width: 100%!important;
		}
		.centre {
		   
		
			.top {
				padding: 5px;
		
				.bt {
					display: flex;
					align-items: center;
		
					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}
		
			.down {
				padding: 5px 5px 0px 5px;
		
				.bt {
					display: flex;
					align-items: center;
		
					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}
		}
		
	}
    .tjan{
		display: flex;
		justify-content: center;
		align-items: center;
		.tjan-je{
			margin: 0 50px;
		}
	}
	.tj{
		background-color: #F5F7F9;
		border-radius: 15px;
		padding: 10px;
		.item{
			display: flex;
			.tj-title{
				font-size: 20px;
			}
			.tj-je{
				font-size: 20px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/home/alliance/alliance3.vue